var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "20px",
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RHP-store-check-your-cart",
    transform: "translate(-83.000000, -702.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "images",
    transform: "translate(17.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(1.000000, 613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(65.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icCard",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7334559,0.15 C27.4184179,0.15 28.0499646,0.442404245 28.5105537,0.906410894 C28.9253519,1.32428688 29.2019943,1.88181531 29.2531747,2.49269694 L29.2617647,2.69818182 L29.2617647,17.3954545 C29.2617647,18.0713798 28.9782987,18.6843402 28.5215753,19.128485 C28.109138,19.5295634 27.5554469,19.7931278 26.9405708,19.8418299 L26.7334559,19.85 L2.67647059,19.85 C1.97975155,19.85 1.34758369,19.5741467 0.889675003,19.1285434 C0.478895689,18.728803 0.208382388,18.1923108 0.158387521,17.596244 L0.15,17.3954545 L0.15,2.73181818 C0.15,2.0317429 0.440266471,1.38630791 0.901357685,0.915681644 C1.31541513,0.493061775 1.86774887,0.210955539 2.47291062,0.15876049 L2.67647059,0.15 L2.67647059,0.15 L26.7334559,0.15 Z M26.7334559,1.66818182 L2.67647059,1.66818182 L2.56751441,1.67581837 C2.35087075,1.70605856 2.14396845,1.82426498 1.98513495,1.9973859 C1.80454683,2.1942183 1.68823529,2.45963387 1.68823529,2.73181818 L1.68823529,2.73181818 L1.68823529,17.3954545 L1.69720427,17.5247386 C1.72679787,17.7356802 1.82810328,17.9225139 1.97839826,18.0635083 C2.15510105,18.2292764 2.40033979,18.3318182 2.67647059,18.3318182 L2.67647059,18.3318182 L26.7334559,18.3318182 L26.8689842,18.3234571 C27.0899921,18.2958902 27.2851804,18.2016823 27.4326992,18.0635951 C27.613478,17.8943743 27.7235294,17.6591324 27.7235294,17.3954545 L27.7235294,17.3954545 L27.7235294,2.69818182 L27.714142,2.56494255 C27.6832332,2.34532638 27.577923,2.14012964 27.4269176,1.98194736 C27.2430283,1.78931828 26.9931251,1.66818182 26.7334559,1.66818182 L26.7334559,1.66818182 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "28.4926471 5.88235294 1.41176471 5.88235294 1.41176471 7.29411765 28.4926471 7.29411765"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.529412, 12.941176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.76470588,0 L0.941176471,0 C0.420705882,0 0,0.527058824 0,1.17647059 C0,1.82588235 0.420705882,2.35294118 0.941176471,2.35294118 L3.76470588,2.35294118 C4.28517647,2.35294118 4.70588235,1.82588235 4.70588235,1.17647059 C4.70588235,0.527058824 4.28517647,0 3.76470588,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64705882,0 L6.82352941,0 C6.30305882,0 5.88235294,0.527058824 5.88235294,1.17647059 C5.88235294,1.82588235 6.30305882,2.35294118 6.82352941,2.35294118 L9.64705882,2.35294118 C10.1675294,2.35294118 10.5882353,1.82588235 10.5882353,1.17647059 C10.5882353,0.527058824 10.1675294,0 9.64705882,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5294118,0 L12.7058824,0 C12.1854118,0 11.7647059,0.527058824 11.7647059,1.17647059 C11.7647059,1.82588235 12.1854118,2.35294118 12.7058824,2.35294118 L15.5294118,2.35294118 C16.0498824,2.35294118 16.4705882,1.82588235 16.4705882,1.17647059 C16.4705882,0.527058824 16.0498824,0 15.5294118,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4117647,0 L18.5882353,0 C18.0677647,0 17.6470588,0.527058824 17.6470588,1.17647059 C17.6470588,1.82588235 18.0677647,2.35294118 18.5882353,2.35294118 L21.4117647,2.35294118 C21.9322353,2.35294118 22.3529412,1.82588235 22.3529412,1.17647059 C22.3529412,0.527058824 21.9322353,0 21.4117647,0 Z",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCard);
export default __webpack_public_path__ + "static/media/icCard.883d4084fb923b15f6e6d05e6a5ac7c5.svg";
export { ForwardRef as ReactComponent };